import { Position } from '@capacitor/geolocation';
import { AppGlobal } from './store.global';

export const appStoreGlobalIS: AppGlobal = {
  user: {} as any,
  collaborator: {} as any,
  company: {} as any,
  isSalesforce: true,

  isLoading: false,
  isSaving: false,

  isWeb: false,
  isSmall: false,
  isMedium: false,
  isLarge: false,
  isPortrait: false,

  innerHeight: 0,
  innerWidth: 0,

  connected: true,

  appointmentsToSync: 0,
  ordersToSync: 0,
  customersToSync: 0,

  appColors: {
    primary: '#8A0808',
    secondary: '#FDFAFA',
    lowFulfillment: '#f5564a',
    normalFulfillment: '#ffc721',
    highFulfillment: '#96c95c',
    text: {
      plan: '#836D22',
      sales: '#000000',
      salesPrev: '#3E3E3E',
      fulfillment: '#0B088A',
      fulfillmentPrev: '#4846A7',
      projection: '#5CB85C',
      salesAlt: '#000000',
    },
    charts: {
      plan: '#FDF3DD',
      sales: '#3CBAB2',
      salesPrev: '#CEEEEC',
      fulfillment: '#0B088A',
      fulfillmentPrev: '#E1E0F0',
      projection: '#5CB85C',
      salesAlt: '#3CBAB2',
    },
  },

  notificationCounter: 0,
  notificationCounterDto: {
    total: 0,
    starred: 0,
    important: 0,
    deleted: 0,
  },

  activeCampaigns: [],
  campaignIds: [],
  campaigns: {},
  resourceIds: [],
  campaignResources: {},
  campaignsLoading: false,
  totalCampaigns: 0,
  campaignsLoaded: 0,

  aiChatHistory: [],

  myFormsAssigned: [],
  myForms: [],
  totalForms: 0,

  isWatchingPosition: false,
  position: {
    coords: { latitude: 0, longitude: 0 },
  } as Position,
};
